<h1 mat-dialog-title>Review Files — {{ data.sectionName }}</h1>
<mat-dialog-content>
  @if (totalCount === 0) {
    <p class="empty">No files in this section.</p>
  }
  @if (totalCount > 0) {
    <div class="summary">
      <span>{{ totalCount }} file{{ totalCount === 1 ? '' : 's' }}</span>
      @if (missingFileCount > 0) {
        <span class="missing"> · {{ missingFileCount }} without a raw file</span>
      }
    </div>
    <table mat-table [dataSource]="rows" class="files-table">
      <ng-container matColumnDef="filename">
        <th mat-header-cell *matHeaderCellDef>Filename</th>
        <td mat-cell *matCellDef="let row" class="filename">{{ row.filename }}</td>
      </ng-container>
      <ng-container matColumnDef="hasFile">
        <th mat-header-cell *matHeaderCellDef>Raw file</th>
        <td mat-cell *matCellDef="let row">
          @if (row.hasRawFile) {
            <mat-icon class="present-icon">check_circle</mat-icon>
          }
          @if (!row.hasRawFile) {
            <mat-icon class="missing-icon">warning</mat-icon>
          }
        </td>
      </ng-container>
      <ng-container matColumnDef="reviewState">
        <th mat-header-cell *matHeaderCellDef>Review</th>
        <td mat-cell *matCellDef="let row">{{ row.reviewState }}</td>
      </ng-container>
      <ng-container matColumnDef="released">
        <th mat-header-cell *matHeaderCellDef>Released</th>
        <td mat-cell *matCellDef="let row">{{ row.released ? 'Yes' : 'No' }}</td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  }
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-stroked-button mat-dialog-close>Close</button>
</mat-dialog-actions>
